import ITEMS_KITS from "./items/kits";
import ITEMS_CATALOG from "./items/catalog";

/**
 * Nomes de itens do Rust: PT (nome usado no site / nos ficheiros de ícones) → EN (nome oficial in-game).
 * Usado no simulador, nos kits e em qualquer lista de itens. Sem entrada → mostra o nome PT.
 * items/kits.js: nomes dos modais/listas de kits; items/catalog.js: catálogo do simulador.
 */
const KIT_APOIADOR = {
    // Kit Apoiador
    "Rifle de Assalto": "Assault Rifle",
    "Rifle L96": "L96 Rifle",
    "Bandagem": "Bandage",
    "Bandagens": "Bandages",
    "Seringa Médica": "Medical Syringe",
    "Seringas médicas": "Medical Syringes",
    "Kit Médico Grande": "Large Medkit",
    "Kits médicos grandes": "Large Medkits",
    "Carne de felino cozinhada": "Cooked Big Cat Meat",
    "Munição 5.56": "5.56 Rifle Ammo",
    "Munição 5.56 de Rifle": "5.56 Rifle Ammo",
    "Munição 5.56 incendiária": "Incendiary 5.56 Rifle Ammo",
    "Munição 5.56 Incendiária de Rifle": "Incendiary 5.56 Rifle Ammo",
    "Munição Antiaérea": "SAM Ammo",
    "Local de Sistema Antiaéreo": "SAM Site",
    "Sentinela Automática": "Auto Turret",
    "Fornalha Elétrica": "Electric Furnace",
    "Fornalha Grande": "Large Furnace",
    "Gerador Pequeno": "Small Generator",
    "Ramificador Elétrico": "Electrical Branch",
    "Ferramenta de Fio": "Wire Tool",
    "Metal de Alta Qualidade": "High Quality Metal",
    "Pólvora": "Gun Powder",
    "Caixão": "Coffin",
    "Sinalizador de Suprimentos": "Supply Signal",
    "Botas": "Boots",
    "Blusão": "Hoodie",
    "Saia de Placas de Trânsito": "Road Sign Kilt",
    "Luvas Táticas": "Tactical Gloves",
    "Máscara de Metal": "Metal Facemask",
    "Colete de Metal": "Metal Chest Plate",
    "Calça": "Pants",
    "Carregador Estendido": "Extended Magazine",
    "Mira Holográfica": "Holosight",
    "Mira Laser": "Weapon Lasersight",
    "Mira 8x": "8x Zoom Scope",
};

export const ITEM_NAMES_EN = { ...ITEMS_CATALOG, ...ITEMS_KITS, ...KIT_APOIADOR };


/** Normaliza para procurar sem diferenças de maiúsculas/acentos de digitação. */
function norm(s) {
    return String(s).trim().toLowerCase();
}

const NORMALIZED = Object.fromEntries(
    Object.entries(ITEM_NAMES_EN).map(([pt, en]) => [norm(pt), en]),
);

export function itemName(ptName, lang) {
    if (!ptName || lang === "pt") return ptName;
    return ITEM_NAMES_EN[ptName] ?? NORMALIZED[norm(ptName)] ?? ptName;
}
